module.exports = __webpack_public_path__ + "img/Flag_of_Kenya.aa572e0e.svg";